import { researchArticles } from "@/content/researchArticles";
import { strategyArticles } from "@/content/strategyArticles";

export const allPublications = [...researchArticles, ...strategyArticles];

export const getPublicationById = (id) => allPublications.find((publication) => publication.slug === id);

export const getPublicationImage = (publication) => publication.hero.src ?? publication.hero.coverSrc;

export const getPublicationImageAlt = (publication) => publication.hero.alt ?? publication.hero.coverAlt;